// extracted by mini-css-extract-plugin
export default {"Wrapper":"HeroHeader-module-Wrapper","Overlay":"HeroHeader-module-Overlay","Content":"HeroHeader-module-Content"};